import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const BoundingBoxCanvas = (props: any) => {
  const { boundingElement } = props;
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const imageUrl = boundingElement.url;
  const regions: any = boundingElement.bounding_box;
  console.log(regions, "regions");

  /**
   * Draws an image onto a canvas once the image is loaded.
   * Adjusts the canvas size based on the parent div dimensions.
   * Clears the canvas before drawing the image to avoid overlaps.
   *
   * @param {string} imageUrl - The URL of the image to load and draw on the canvas.
   * @param {object} canvasRef - Reference to the canvas element.
   */
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Load the image
    const image = new Image();
    image.src = imageUrl;

    image.onload = () => {
      const parentDiv: any = document.getElementsByClassName(
        "livis-inference-canvas-wrap"
      );
      const canvasWidth = parentDiv[0]?.offsetWidth;
      const canvasHeight = parentDiv[0]?.offsetHeight;

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        console.error("Canvas context is not available.");
        return;
      }

      const imgWidth = image.width;
      const imgHeight = image.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      let scaleFactor = 1;
      if (imgWidth > canvasWidth || imgHeight > canvasHeight) {
        const widthRatio = canvasWidth / imgWidth;
        const heightRatio = canvasHeight / imgHeight;
        scaleFactor = Math.min(widthRatio, heightRatio);
      }

      const xOffset = (canvasWidth - imgWidth * scaleFactor) / 2;
      const yOffset = (canvasHeight - imgHeight * scaleFactor) / 2;

      ctx.drawImage(
        image,
        xOffset,
        yOffset,
        imgWidth * scaleFactor,
        imgHeight * scaleFactor
      );

      for (let i = 0; i < regions?.length; i++) {
        const { x, y, w, h, cls } = regions[i];

        // Convert the bounding box properties to the scaled canvas coordinates
        const scaledX = xOffset + x * imgWidth * scaleFactor;
        const scaledY = yOffset + y * imgHeight * scaleFactor;
        const scaledWidth = w * imgWidth * scaleFactor;
        const scaledHeight = h * imgHeight * scaleFactor;

        // Draw bounding box
        ctx.strokeStyle = "#ff0000";
        ctx.strokeRect(scaledX, scaledY, scaledWidth, scaledHeight);

        // Fill bounding box with transparent color
        ctx.fillStyle = "#ff000030";
        ctx.fillRect(scaledX, scaledY, scaledWidth, scaledHeight);

        // Add label above the bounding box
        ctx.font = "16px Arial";
        ctx.fillStyle = "#ff0000";
        ctx.fillText(cls, scaledX, scaledY - 5);
      }
    };
  }, [imageUrl, boundingElement]);

  return (
    <div className="livis-inference-canvas-wrap">
      <canvas
        ref={canvasRef}
        className="livis-testing-inference-result-image"
      ></canvas>
    </div>
  );
};

BoundingBoxCanvas.propTypes = {
  boundingElement: PropTypes.any,
};

export default BoundingBoxCanvas;
